import React from 'react';
import Zoom from 'react-medium-image-zoom';

const title = "Inventory Valuation Summary";
const description = `The Inventory Valuation Summary Report is a critical financial document that provides a high-level assessment of the monetary value of a company's unsold inventory at a specific point in time. Its primary function is to calculate the Inventory Asset Value for the Balance Sheet, which is determined by multiplying the quantity on hand for each item by its unit cost.`;

const images = [
    '/images/reports/purchase-by-supplier/purchase-by-supplier.png', // 0
];


const InventoryValuationSummary: React.FC = () => {

    return (
        <div className="max-w-4xl lg:max-w-5xl min-h-screen bg-gray-50 flex gap-2">
            <div className="overflow-auto mx-auto flex-2">

                <div className="mb-6">
                    <h1 className="text-3xl font-bold pt-4 text-gray-900">
                        {title}
                    </h1>
                    <p className="text-gray-600 mt-4">
                        {description}
                    </p>
                    <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6 my-6">
                        <Zoom>
                            <img
                                src={images[0]}
                                alt={title}
                                className="w-full max-w-4xl h-auto border border-gray-200 rounded-lg shadow-sm mx-auto"/>
                        </Zoom>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default InventoryValuationSummary;
